import(/* webpackMode: "eager" */ "/codebuild/output/src1365005527/src/micrographer/src/app/(main)/shop/Shop.tsx")